import React from 'react';
import ProForm from '@ant-design/pro-form';

import { F } from '@/utils/intl';
import SkillSelect from '@/components/SkillsDrawer/SkillSelect';

type UserSkillsFieldProps = {
  disabled?: boolean;
};

/** The user's skills, sent to the API as slugs. Render inside a form, behind SKILLS_ACCESS.view. */
const UserSkillsField: React.FC<UserSkillsFieldProps> = ({ disabled }) => (
  <ProForm.Item name="skills" label={<F id="entity.skill.plural" defaultMessage="Skills" />}>
    <SkillSelect disabled={disabled} />
  </ProForm.Item>
);

export default React.memo(UserSkillsField);
